<p>
  The Find a Migrant and Seasonal Head Start (MSHS) locator tool allows users to search for centers providing
  comprehensive Head Start services. Users may search for MSHS centers by allowing the tool to detect their location
  automatically or by entering search criteria such as an address or place name.
</p>
